module.exports = __webpack_public_path__ + "img/icon_real_time_4.43182cfb.png";